import { TrailDifficulty, TrailType, CarType, TrailTag } from './Trails';

export interface SingleRoute {
  [key: string]: any;
  id: number;
  name?: string;
  description?: string;
  difficulty?: TrailDifficulty;
  state: RouteState;
  status: RouteStatus;
  carType?: string;
  type?: TrailType;
  time?: string;
  distance: number;
  elevationGain: number;
  rating: number;
  startingPoint: number[];
  autoDetectedCountry: string;
  autoDetectedCity: string;
  reference: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: number;
  ownerId: number;
  creator: RouteCreator;
  photos: string[];
  tags: TrailTag[];
  trailPath: [number, number, number][];
}

export interface RouteCreator {
  id: number;
  name: string;
  email: string;
}

export enum RouteState {
  Draft = 'draft',
  Personal = 'personal',
  Public = 'public',
}

export enum RouteStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}
